// extracted by mini-css-extract-plugin
module.exports = {"cart-intermediate-drawer":"CartIntermediateDrawer_cart-intermediate-drawer__FO7bw"};